import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit {
  private gridApi;
  private gridColumnApi;
  defaultColDef = { resizable: true, cellStyle:{'font-size':'14px'} };
  columnDefs = [
    {headerName: 'Component Name', field: 'componentName' },
    {headerName: 'Start Date', field: 'startDate' },
    {headerName: 'End Date', field: 'endDate'},
    {headerName: 'Service Provider', field: 'serviceProvider'},
    {headerName: 'Monthly Authorized Hours', field: 'authorizedHours'},
    {headerName: 'Total Authorized Hours', field: 'totalAuthorizedhours'},
    {headerName: 'Total Reported Hours', field: 'totalReportedhours'}
];

rowData = [
    {componentName:'English as a 2nd Language',startDate:'10/01/2018',endDate:'10/31/2018',serviceProvider:'Arkansas Career Education',authorizedHours:'1.0',totalAuthorizedhours:'1.0',totalReportedhours:'1.0'},
    {componentName:'English as a 2nd Language',startDate:'10/01/2018',endDate:'10/31/2018',serviceProvider:'Arkansas Career Education',authorizedHours:'5.0',totalAuthorizedhours:'10.7',totalReportedhours:'5.0'},
    {componentName:'English as a 2nd Language',startDate:'10/01/2018',endDate:'10/31/2018',serviceProvider:'Arkansas Career Education',authorizedHours:'4.0',totalAuthorizedhours:'8.0',totalReportedhours:'4.0'},
];
  constructor() { }

  ngOnInit() {
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.setDomLayout("autoHeight");
  }
}



// WEBPACK FOOTER //
// ./src/app/summary/summary.component.ts